import type { PepDictionary } from "../types";

export const en: PepDictionary = {
  "nav.products": "Products",
  "nav.solutions": "Solutions",
  "nav.industries": "Industries",
  "nav.package": "Configure",
  "nav.why": "Why ITaaS",
  "nav.docs": "Documentation",
  "nav.knowledge": "Knowledge",
  "nav.marketplace": "Marketplace",
  "nav.partners": "Partners",
  "nav.affiliation": "Affiliation",
  "nav.about": "About",
  "nav.contact": "Contact",
  "nav.search": "Search",
  "nav.searchPlaceholder": "Search…",
  "nav.login": "Sign in",
  "nav.trial": "Free trial",
  "nav.compose": "Compose my solution",
  "nav.demo": "Request a demo",
  "nav.toggleTheme": "Toggle theme",
  "nav.menu": "Menu",
  "nav.more": "More",
  "footer.tagline":
    "Business software platform by ITaaS RDC — education, HR, operations, finance and industry.",
  "footer.products": "Products",
  "footer.catalog": "Catalog",
  "footer.marketplace": "Marketplace",
  "footer.solutions": "Solutions",
  "footer.industries": "Industries",
  "footer.resources": "Resources",
  "footer.documentation": "Documentation",
  "footer.knowledge": "Knowledge Center",
  "footer.package": "Configure your solution",
  "footer.why": "Why ITaaS",
  "footer.rights": "© {year} ITaaS RDC. All rights reserved.",
  "footer.license": "Commercial software — licenses and subscriptions.",
  "common.loading": "Loading…",
  "common.learnMore": "Learn more →",
  "common.contactSales": "Contact sales",
  "common.requestDemo": "Request a demo",
  "common.freeTrial": "Free trial",
  "common.back": "Back",
  "common.accept": "Accept",
  "common.decline": "Decline",
  "home.seo.title": "ITaaS Suite | Business software platform in the DRC",
  "home.seo.description":
    "Integrated business software for education, human resources, finance, inventory, operations and industry — published and supported by ITaaS RDC in Lubumbashi.",
  "home.kicker": "ITaaS Suite · by ITaaS RDC",
  "home.title": "ITaaS Suite | Business software platform in the DRC",
  "home.subtitle":
    "An integrated suite to run education, human resources, operations, finance and industry — designed and supported from Lubumbashi.",
  "home.cta.trial": "Request a demonstration",
  "home.cta.products": "Discover the solutions",
  "home.pillars.africa": "Rooted in Lubumbashi",
  "home.pillars.africa.text":
    "ITaaS RDC publisher and support for professional organizations in the DRC.",
  "home.pillars.modular": "Modular adoption",
  "home.pillars.modular.text": "Activate the products you need, progressively.",
  "home.pillars.identity": "A coherent suite",
  "home.pillars.identity.text":
    "Business applications on a shared platform — identity, data, integration.",
  "home.pillars.verticals": "Covered domains",
  "home.pillars.verticals.text":
    "Education, human capital, operations, finance, industry and mining.",
  "home.stats.modules": "modules",
  "home.stats.ga": "available",
  "home.stats.verticals": "verticals",
  "home.catalog.title": "Solutions",
  "home.catalog.subtitle": "Explore the published ITaaS Suite solutions",
  "home.regions.title": "Presence",
  "home.ctaBand.title": "Let’s build the solution for your organization.",
  "home.ctaBand.text": "Request a demonstration or contact ITaaS RDC in Lubumbashi.",
  "products.seo.title": "ITaaS product catalog",
  "products.seo.description":
    "ERP, HR, inventory, Hospitol, Edu, MinePortal, security, transit — modular software for DRC and Africa. 30-day free trial.",
  "products.kicker": "Modular suite · DRC & Francophone Africa",
  "products.title": "Software that adapts to your business, not the other way around",
  "products.subtitle":
    "School, hospital, mine, SME or NGO — compose only the modules you need. One identity, one billing, local support.",
  "products.searchPlaceholder": "Search: school, mining, pharmacy, HR…",
  "products.cta.trial": "30-day free trial",
  "products.cta.solutions": "Browse solutions",
  "products.cta.industries": "By industry",
  "products.stats.products": "Products",
  "products.stats.available": "Available",
  "products.stats.verticals": "Verticals",
  "products.stats.sectors": "Industries",
  "products.stats.footnote": "Commercial software · USD & CDF · Assisted deployment",
  "products.spotlight.title": "Flagship business solutions",
  "products.spotlight.subtitle": "Full verticals composed on the ITaaS platform",
  "products.sectors.title": "Where to start?",
  "products.catalog.title": "All modules",
  "products.catalog.subtitle": "Filter by category or search for a specific product",
  "products.filter.all": "All",
  "products.empty": "No products match your search.",
  "products.ctaBand.title": "Not sure where to start?",
  "products.ctaBand.text":
    "Our experts will guide you to the right package — free trial, demo or custom quote.",
  "search.title": "Search",
  "search.placeholder": "ERP, mining, pharmacy, API…",
  "search.submit": "Search",
  "search.loading": "Searching…",
  "search.noResults": "No results for \"{query}\".",
  "search.type.product": "Product",
  "search.type.solution": "Solution",
  "search.type.industry": "Industry",
  "search.type.doc": "Documentation",
  "search.type.marketplace": "Marketplace",
  "search.type.partner": "Partner",
  "analytics.consent.title": "Analytics",
  "analytics.consent.text":
    "We use anonymous statistics (page views, no third-party cookies) to improve this site. No personal data is sold.",
  "analytics.consent.accept": "Accept",
  "analytics.consent.decline": "Decline",
};
